import { Divider, Row, Col, Checkbox } from 'antd';
import React, { useState, useEffect } from 'react';
import { IRoleResponseData } from "../../types/Role";
import PermissionService from '../../services/PermissonService';
import RoleService from '../../services/RoleService';
import { IPermissionResponseData } from '../../types/Permission';

interface RoleDetailProps {
    id: number;
}

const translateGroup = (group: string): string => {
    switch (group) {
        case 'roles':
            return 'Rol';
        case 'permission':
            return 'Yetki';
        case 'attribute':
            return 'Parametre';
        case 'company':
            return 'Firma';
        case 'users':
            return 'Kullanıcılar';
        case 'report':
            return 'Rapor';
        case 'settings':
            return 'Ayarlar';
        case 'proposal':
            return 'Teklifler';
        case 'ticket':
            return 'Destek';
        default:
            return group;
    }
};

const translateAction = (action: string): string => {
    switch (action) {
        case 'create':
            return 'Ekleme';
        case 'delete':
            return 'Silme';
        case 'update':
            return 'Düzenleme';
        case 'list':
            return 'Listeleme';
        case 'show':
        case 'read':
            return 'Görüntüleme';
        default:
            return action;
    }
};

const RoleDetail: React.FC<RoleDetailProps> = ({ id }) => {
    const [role, setRole] = useState<IRoleResponseData | null>(null);
    const [groupedPermissions, setGroupedPermissions] = useState<{ [key: string]: IPermissionResponseData[] }>({});
    const [selectedPermissions, setSelectedPermissions] = useState<number[]>([]);

    useEffect(() => {
        getPermissions();
    }, [id]);

    const getRole = (id: number) => {
        RoleService.get(id)
            .then((response: any) => {
                setRole(response.data);
                const ids: number[] = response.data.permissions.map((permission: any) => permission.id);
                setSelectedPermissions(ids);
            })
            .catch((e: Error) => {
                console.log(e);
            });
    };

    const getPermissions = () => {
        PermissionService.getAll()
            .then((response: any) => {
                const sortedData = [...response.data].sort((a, b) => a.name.localeCompare(b.name));
                groupPermissions(sortedData);
                getRole(id);
            })
            .catch((e: Error) => {
                console.log(e);
            });
    };

    const groupPermissions = (permissions: IPermissionResponseData[]) => {
        const grouped = permissions.reduce((acc, permission) => {
            const [group] = permission.name.split('.');
            if (!acc[group]) {
                acc[group] = [];
            }
            acc[group].push(permission);
            return acc;
        }, {} as { [key: string]: IPermissionResponseData[] });

        setGroupedPermissions(grouped);
    };

    return (
            <div className="role-detail-content">
                <h4>Rol Adı</h4>
                <p>{role?.name}</p>
                <Divider />
                <h4>Rol Yetkileri</h4>
                {Object.keys(groupedPermissions).map(group => (
                    <div key={group}>
                    <Divider>{translateGroup(group)}</Divider>
                        <Row gutter={[16, 16]} className="permission-row">
                            {groupedPermissions[group].map(permission => (
                                <Col key={permission.id} span={6}>
                                    <Checkbox
                                        value={permission.id}
                                        checked={selectedPermissions.includes(permission.id)}
                                        disabled
                                    >
                                        {translateAction(permission.name.split('.')[1])}
                                    </Checkbox>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </div>
    );
};

export default RoleDetail;
